import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";
import { TESTIDS } from "@/constants/testIds/site";

export const StickyTourCTA = () => (
  <Link
    to="/contact"
    data-testid={TESTIDS.stickyTourBtn}
    className="hidden md:inline-flex fixed bottom-7 right-7 z-30 items-center gap-2 bg-[#FFD43A] hover:bg-[#FFC700] text-[var(--ink)] text-[12px] font-extrabold tracking-[0.12em] uppercase rounded-[4px] pl-5 pr-6 py-4 border-2 border-[var(--ink)] shadow-[6px_6px_0_0_var(--ink)] hover:shadow-[8px_8px_0_0_var(--ink)] hover:-translate-x-[2px] hover:-translate-y-[2px] active:translate-x-[2px] active:translate-y-[2px] active:shadow-[2px_2px_0_0_var(--ink)] transition"
  >
    <Calendar size={15} strokeWidth={1.6} />
    Schedule a Tour
  </Link>
);

export default StickyTourCTA;
